import { render, staticRenderFns } from "./InfoZakupki.vue?vue&type=template&id=c4f82a12"
import script from "./InfoZakupki.vue?vue&type=script&lang=js"
export * from "./InfoZakupki.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports